define(
    'atn/globals',['knockout'],
    function(ko) {
        'use strict';

        var isLoggedOut = ko.observable(true);
        var showErrorPage = false;
        var reInitAt = ko.observable();

        return {
            isLoggedOut: isLoggedOut,
            showErrorPage: showErrorPage,
            reInitAt: reInitAt
        };
    });
